import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentResponse } from '../../model/document-response.model';
import { DocumentDto } from '../../model/document.model';
import { ApiUrlService } from '../api-url.service';
import { HttpClientService } from './http-client.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentsClientService {
    private httpClient = inject(HttpClientService);
    private apiUrlService = inject(ApiUrlService);

    public getReferralDocument(referralId: string): Observable<DocumentResponse> {
        return this.httpClient.get(this.apiUrlService.getPreventivniUrl() + `/documents/referrals/${referralId}`);
    }

    public getDocumentsByReservationId(reservationId: string): Observable<DocumentDto[]> {
        return this.httpClient.get(this.apiUrlService.getPreventivniUrl() + `/documents/reservations/${reservationId}`);
    }

    public getDocumentByMaskedId(maskedDocumentId: string): Observable<DocumentDto | null> {
        return this.httpClient.get(this.apiUrlService.getPreventivniUrl() + `/documents/${maskedDocumentId}`);
    }
}
